<template>
  <div v-if="!hidden" class="icon-color-picker">
    <div class="text-text-label text-xs w-full mb-3">{{ label || $t('colorLabel') }}</div>
    <div class="swatches">
      <button
          v-for="swatch in palette"
          :key="swatch.id || swatch.bg"
          type="button"
          class="swatch"
          :class="{
            selected: isSelected(swatch),
            transparent: isTransparent(swatch)
          }"
          :style="swatchStyle(swatch)"
          :title="swatchTitle(swatch)"
          @click="pick(swatch)"
      >
        <span class="dot"/>
      </button>
    </div>
  </div>
</template>

<script>
import {
  ICON_PALETTE,
  colorsForBg,
  isTransparentBg
} from '@/components/icons/MKIcons/iconPalette';

export default {
  name: 'IconColorPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    hidden: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      palette: ICON_PALETTE
    };
  },
  methods: {
    isTransparent(swatch) {
      return isTransparentBg(swatch.bg);
    },
    isSelected(swatch) {
      if (this.isTransparent(swatch)) return isTransparentBg(this.value);
      if (isTransparentBg(this.value)) return false;
      return String(this.value).toLowerCase() === String(swatch.bg).toLowerCase();
    },
    swatchStyle(swatch) {
      if (this.isTransparent(swatch)) return { '--swatch': '#9b9ba6' };
      return { '--swatch': swatch.bg };
    },
    swatchTitle(swatch) {
      if (this.isTransparent(swatch)) return this.$t('transparent');
      return swatch.bg;
    },
    pick(swatch) {
      const { bg, color } = colorsForBg(swatch.bg);
      this.$emit('input', bg);
      this.$emit('change', { bg, color });
    }
  },
  i18n: {
    messages: {
      en: { colorLabel: 'Icon color', transparent: 'Transparent' },
      ru: { colorLabel: 'Цвет иконки', transparent: 'Прозрачный' }
    }
  }
};
</script>

<style scoped lang="scss">
.icon-color-picker {
  margin-top: -1.5rem;
}

.swatches {
  display: grid;
  grid-template-columns: repeat(8, 2.6rem);
  column-gap: 0.5rem;
  row-gap: 0.8rem;
  width: 24.3rem;
}

.swatch {
  box-sizing: border-box;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 9999px;
  border: 1px solid #dddbe8;
  background: #fff;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  transition: transform 0.15s ease;

  .dot {
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 9999px;
    background: var(--swatch);
  }

  &.transparent .dot {
    background-color: #fff;
    background-image:
      linear-gradient(45deg, #d0d4dc 25%, transparent 25%),
      linear-gradient(-45deg, #d0d4dc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #d0d4dc 75%),
      linear-gradient(-45deg, transparent 75%, #d0d4dc 75%);
    background-size: 8px 8px;
    background-position: 0 0, 0 4px, 4px -4px, -4px 0;
  }

  &:hover {
    transform: scale(1.06);
  }

  &.selected {
    border-width: 2px;
    border-color: var(--swatch);
  }
}
</style>
